<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page" :class="pageClass">
        <div class="content">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        pageClass: 'login-page'
      };
    },
    methods: {
      setPageClass() {
        this.pageClass = `${this.$route.name}-page`.toLowerCase();
      }
    },
    mounted() {
      this.setPageClass();

    },
    watch: {
      $route() {
        this.setPageClass();
      }
    }
  };
</script>
<style lang="scss">
  .full-page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.8125rem;
    background: $background-green-patina !important;

    @include media-breakpoint-up(lg) {
      padding: 1.8125rem 1.5rem;
    }

    @media(max-height: 710px) {
      padding: 0.8125rem;
    }

    h1 {
      color: $primary !important;
      font-size: 2.925vh;
      font-weight: bold;
      margin-top: 16.92708333vh;
      margin-bottom: 0;
      line-height: 1;
    }

    h3 {
      color: $secondary !important;
      font-size: 2.60416667vh;
      font-weight: bold;
      margin-bottom: 13.02083333vh;
    }

    p {
      color: $secondary;
    }

    .submit-button {
      margin-top: 4.16666667vh;
      width: 10.9375rem;
      height: 9.11458333vh;
      font-size: 1.82291667vh;
      font-weight: 400;
      border-radius: 0.5rem;
      box-shadow: none;
      cursor: pointer;
      text-transform: uppercase;
    }

    .content {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: $white;

      .lp-form-input {
        position: relative;
        display: block;
        margin-top: 4.42708333vh;

        a {
          position: absolute;
          top: 0;
          right: 0.75rem;
          bottom: 0;
          font-size: 1.62291667vh;
          text-decoration: underline;
          line-height: 5.3125vh;
        }

        input {
          border: 0.0625rem solid #689d98;
          color: $secondary;
          border-radius: 0.5rem;
          height: 5.72916667vh;
          font-size: 1.82291667vh;
          padding-left: 13.671875vh;
          padding-bottom: 0.9vh;
          transition: border-color 0.3s ease-in-out,color 0.3s ease-in-out,padding-left 0.3s ease-in-out;
          width: 100%;
          outline: none;

          &.has-danger {
            border-color: $danger;
          }

          &:focus {
            border-color: $secondary;
            box-shadow: none;
            padding-left: 1.25rem;
            ~ label {
              transform: translateY(-5vh);
            }

            &.has-danger {
              border-color: $danger;
            }

          }
        }

        label {
          position: absolute;
          top: 0;
          left: 0.75rem;
          bottom: 0;
          font-size: 1.5625vh;
          font-weight: bold;
          color: #689d98;
          line-height: 5.72916667vh;
          text-transform: uppercase;
          z-index: 1;
          transition: transform 0.3s ease-in-out;
        }
      }

      .popup-close {
        position: absolute;
        top: 0.875rem;
        right: 1.25rem;
        display: block;
        width: 2.375rem;
        height: 2.375rem;
        min-width: 30px;
        min-height: 30px;
        background-color: #90c14f;
        color: #fff;
        border-radius: 100%;
        font-size: 2rem;
        text-align: center;
        line-height: 2.4rem;
        transform: rotateZ(45deg);
        z-index: 1;
        cursor: pointer;

        @include media-breakpoint-down(xs) {
          top: 0.2rem;
          display: block;
          width: 0.375rem;
          height: 0.375rem;
          min-width: 25px;
          min-height: 25px;
          font-size: 1.3rem;
          line-height: 1.6rem;
        }
      }

      .left-panel {
        position: absolute;
        left: 0;
        top: 0;
        width: 50%;
        height: 100%;
        padding-left: 7.8rem;

        @include media-breakpoint-down(xs) {
          width: 100%;
        }

        @include media-breakpoint-up(xs) {
          width: 70%;
        }

        @include media-breakpoint-up(md) {
          width: 60%;
        }

        @include media-breakpoint-up(lg) {
          width: 50%;
        }

        @include media-breakpoint-down(lg) {
          padding-left: 5.14634146vw;
        }

        .language-switch-container {
          position: absolute;
          top: 1.75rem;
          width: 100%;
          @include media-breakpoint-down(md) {
            top: 0;
          }
        }

        .left-inner {
          @include media-breakpoint-down(md) {
            width: 100%;
            max-width: 25rem;
            padding-right: 2rem;
          }

          .lp-signup {
            p {
              color: $secondary;
              display: inline;
              font-size: 0.75rem;
              margin-right: 2.75rem;
            }
            position: absolute;
            top: 1.75rem;
            right: 1.75rem;
            line-height: 2.625rem;
          }

          form {
            max-width: 25rem;
          }
        }
      }

      .right-panel {
        position: absolute;
        right: 0;
        top: 0;
        width: 50%;
        height: 100%;
        background-image: url('/img/square-pattern.jpg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

        @include media-breakpoint-down(xs) {
          display: none;
        }

        @include media-breakpoint-down(sm) {
          width: 30%;
        }

        @include media-breakpoint-up(md) {
          width: 40%;
        }

        @include media-breakpoint-up(lg) {
          width: 50%;
        }

      }
    }
  }

  .has-danger {
    &:after {
      display: none !important;
    }
  }

  .has-error {
    color: $danger;
    margin-top: 4px;
    margin-left: 0.75rem;
  }
</style>
